const castInfo = [
  {
    id: "cast/agent-brown.jpeg",
    name: "Paul Goddard",
    played: "Agent Brown",
  },
  {
    id: "cast/agent-jones.webp",
    name: "Robert Taylor",
    played: "Agent Jones",
  },
  {
    id: "cast/agent-smith.jpeg",
    name: "Hugo Weaving",
    played: "Agent Smith",
  },
  {
    id: "cast/apoc.jpeg",
    name: "Julian Arahanga",
    played: "Apoc",
  },
  {
    id: "cast/bane.webp",
    name: "Ian Bliss",
    played: "Bane",
  },
  {
    id: "cast/bugs.webp",
    name: "Jessica Henwick",
    played: "Bugs",
  },
  {
    id: "cast/counsilor-hamann.png",
    name: "Anthony Zerbe",
    played: "Counsilor Hamann",
  },
  {
    id: "cast/cypher.webp",
    name: "Joe Pantoliano",
    played: "Cypher",
  },
  {
    id: "cast/dozer.webp",
    name: "Antony Ray Parker",
    played: "Dozer",
  },
  {
    id: "cast/keymaker.webp",
    name: "Randall Duk Kim",
    played: "Keymaker",
  },
  {
    id: "cast/woman-In-red.webp",
    name: "Fiona Johnson",
    played: "Woman In Red",
  },
  {
    id: "cast/lexy.webp",
    name: "Eréndira Ibarra",
    played: "Lexy",
  },
  {
    id: "cast/link.jpeg",
    name: "Harold Perrineau",
    played: "Link",
  },
  {
    id: "cast/lock.webp",
    name: "Harry Lennix",
    played: "Commander Lock",
  },
  {
    id: "cast/mouse.jpeg",
    name: "Matt Doran",
    played: "Mouse",
  },
  {
    id: "cast/merovingain.jpeg",
    name: "Lambert Wilson",
    played: "Merovingain",
  },
  {
    id: "cast/mifune.webp",
    name: "Nathaniel Lees",
    played: "Captain Mifune",
  },
  {
    id: "cast/morpheus.jpeg",
    name: "Laurence Fishburne",
    played: "Morpheus",
  },
  {
    id: "cast/neo.jpeg",
    name: "Keanu Reeves",
    played: "Neo",
  },
  {
    id: "cast/niobe.jpeg",
    name: "Jada Pinkett Smith",
    played: "Niobe",
  },
  {
    id: "cast/persephone.png",
    name: "Monica Bellucci",
    played: "Persephone",
  },
  {
    id: "cast/rama-kandra.png",
    name: "Bernard White",
    played: "Rama Kandra",
  },
  {
    id: "cast/rhineheart.webp",
    name: "David Aston",
    played: "Rhineheart",
  },
  {
    id: "cast/sati.webp",
    name: "Tanveer K. Atwal",
    played: "Sati",
  },
  {
    id: "cast/seraph.jpeg",
    name: "Collin Chou",
    played: "Seraph",
  },
  {
    id: "cast/switch.jpeg",
    name: "Belinda McClory",
    played: "Switch",
  },
  {
    id: "cast/tank.webp",
    name: "Anthony Ray Parker",
    played: "Tank",
  },
  {
    id: "cast/the-architect.webp",
    name: "Helmut Bakaitis",
    played: "The Architect",
  },
  {
    id: "cast/train-man.jpeg",
    name: "Bruce Spence",
    played: "Trainman",
  },
  {
    id: "cast/trinity.jpeg",
    name: "Carrie-Anne Moss",
    played: "Trinity",
  },
  {
    id: "cast/white-rabbit.webp",
    name: "Ada Nicodemou",
    played: "White Rabbit",
  },
  {
    id: "cast/zee.jpeg",
    name: "Nona Gaye",
    played: "Zee",
  },
];

export default castInfo;
